import { CTeStockState, enumLabelExpirationDayStock } from "models/CTEs";

export const checkLabelExpirationDay = (item: CTeStockState) => {
  if (Number(item.daysToExpire) > 0 && Number(item.daysToExpire) <= 15)
    return enumLabelExpirationDayStock.VENCIMENTO_EM_15_DIAS;

  if (Number(item.daysToExpire) > 15 && Number(item.daysToExpire) <= 30)
    return enumLabelExpirationDayStock.VENCIMENTO_EM_30_DIAS;

  if (Number(item.daysToExpire) > 30 && Number(item.daysToExpire) <= 60)
    return enumLabelExpirationDayStock.VENCIMENTO_EM_60_DIAS;

  return enumLabelExpirationDayStock.Ok;
};